<template>
  <footer class="Footer" :class="mode">
    <div v-if="!!$slots.iconTop || !!$slots.iconBottom || contents.length" class="footer-contents">
      <div class="inner">
        <div v-if="$slots.iconTop" class="footer-icons">
          <slot name="iconTop"></slot>
        </div>
        <div class="contents">
          <div
            v-for="(content, index) in contents"
            :key="index"
            class="content"
          >
            <div class="footer-headline">
              <Thunder classs="ball" v-if="mode === 'pm'" />
              {{ content.headline }}
            </div>
            <ul class="items">
              <li
                class="item"
                v-for="(item, itemIdx) in content.items"
                :key="itemIdx"
              >
                <NuxtLink class="item-text" :to="item.link" :target="item.isExternal ? '_blank' : undefined">
                  {{ item.text }}
                  <External v-if="item.isExternal" />
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="$slots.iconBottom" class="footer-icons">
          <slot name="iconBottom"></slot>
        </div>
      </div>
    </div>
    <div class="copyrights">
      <NuxtLink :to="home">
        <picture>
          <source type="image/webp" srcset="https://assets.ka-nabell.com/common/logo.webp" width="130" height="32" class="footer-logo">
          <img src="https://assets.ka-nabell.com/common/logo.png" alt="カーナベル" width="130" height="32" class="footer-logo" />
        </picture>
      </NuxtLink>
      <p class="copyright">&copy; {{ thisYear }} KA-NABELL</p>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { Thunder, External } from "@ka-nabellinc/ka-nabell-icons";
export default defineComponent({
  components: {
    Thunder,
    External,
  },
  props: {
    mode: {
      type: String as () => "default" | "pm",
      default: "default",
    },
    contents: {
      type: Array as () => {
        headline: string;
        items: {
          text: string;
          link: string;
          isExternal?: boolean;
        }[];
      }[],
      default: () => [],
    },
    home: {
      type: String,
      default: "/",
    },
  },
  setup() {
    const thisYear = new Date().getFullYear()

    return {
      thisYear,
    };
  },
});
</script>

<style scoped>
.Footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 auto;
}

@media screen and (min-width: 430px) {
  .Footer {
    width: 430px;
  }
}

.footer-contents {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  width: 100%;
}

.default .footer-contents {
  background: var(--semantic-colors-background-lightgray);
}

.pm .footer-contents {
  background: var(--primitive-colors-basic-yellow-100);
}

.inner {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
}

.contents {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}

.content {
  width: 100%;
  flex: 1;
}

.footer-headline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.3px;
}

.default .footer-headline {
  color: var(--semantic-colors-text-black);
  border-bottom: 2px solid var(--primitive-colors-neutral-black-600);
}

.pm .footer-headline {
  color: var(--semantic-colors-text-black);
  border-bottom: 2px solid var(--primitive-colors-basic-yellow-400);
}

.ball {
  display: inline-block;
  width: 14px;
  height: 14px;
}

.items {
  margin: 0;
  padding: 0;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 21px;
}

.item {
  display: flex;
  position: relative;
  width: 100%;
  list-style: none;
}

.item-text {
  text-decoration: none;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.12px;
  display: flex;
  gap: 4px;
  align-items: center;
}

.default .item-text {
  color: var(--semantic-colors-text-black);
}

.pm .item-text {
  color: var(--semantic-colors-text-black);
}

.footer-icons {
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
}

.copyrights {
  display: flex;
  padding: 20px 12px 28px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}

.footer-logo {
  vertical-align: middle;
}

.copyright {
  color: var(--primitive-colors-neutral-black-800-black);
  text-align: center;
  font-size: 11px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.11px;
  margin: 0;
}
</style>
